module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-sharp-light-300.ttf";